"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageOptionMap = void 0;
exports.getLanguageOptions = getLanguageOptions;
exports.getDefaultLanguage = getDefaultLanguage;
exports.languageNode = languageNode;
exports.folderAndAppNameCondition = folderAndAppNameCondition;
exports.scaffoldQuestionForVSCode = scaffoldQuestionForVSCode;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const localizeUtils_1 = require("../../../common/localizeUtils");
const metadata_1 = require("../../../component/generator/templates/metadata");
const constants_1 = require("../../constants");
const create_1 = require("../../create");
const questionNames_1 = require("../../questionNames");
const CapabilityOptions_1 = require("./CapabilityOptions");
const ProjectTypeOptions_1 = require("./ProjectTypeOptions");
const rootNode_1 = require("./rootNode");
exports.LanguageOptionMap = new Map([
    [constants_1.ProgrammingLanguage.JS, { id: constants_1.ProgrammingLanguage.JS, label: "JavaScript" }],
    [constants_1.ProgrammingLanguage.TS, { id: constants_1.ProgrammingLanguage.TS, label: "TypeScript" }],
    [constants_1.ProgrammingLanguage.CSharp, { id: constants_1.ProgrammingLanguage.CSharp, label: "C#" }],
    [constants_1.ProgrammingLanguage.PY, { id: constants_1.ProgrammingLanguage.PY, label: "Python" }],
    [constants_1.ProgrammingLanguage.Common, { id: constants_1.ProgrammingLanguage.Common, label: "None" }],
    [constants_1.ProgrammingLanguage.None, { id: constants_1.ProgrammingLanguage.None, label: "None" }],
]);
function getLanguageOptions(inputs) {
    const templateName = inputs[questionNames_1.QuestionNames.TemplateName];
    const languages = (0, metadata_1.getAllTemplatesOnPlatform)(inputs.platform)
        .filter((t) => t.name === templateName)
        .map((t) => t.language)
        .filter((lang) => lang !== undefined);
    const languageOptions = languages.map((lang) => exports.LanguageOptionMap.get(lang) || {
        id: constants_1.ProgrammingLanguage.Common,
        label: "None",
    });
    if (inputs[questionNames_1.QuestionNames.ProjectType] === ProjectTypeOptions_1.ProjectTypeOptions.teamsAgentsAndApps().id) {
        const pythonOptionIndex = languageOptions.findIndex((option) => option.id === constants_1.ProgrammingLanguage.PY);
        if (pythonOptionIndex !== -1) {
            languageOptions[pythonOptionIndex] = {
                ...languageOptions[pythonOptionIndex],
                description: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.option.description.preview"),
            };
        }
    }
    return languageOptions;
}
function getDefaultLanguage(inputs) {
    const options = getLanguageOptions(inputs);
    return options[0]?.id;
}
function languageNode() {
    return {
        condition: (inputs) => {
            const templateName = inputs[questionNames_1.QuestionNames.TemplateName];
            const languages = (0, metadata_1.getAllTemplatesOnPlatform)(inputs.platform)
                .filter((t) => t.name === templateName)
                .map((t) => t.language)
                .filter((lang) => lang !== "none" && lang !== undefined);
            return languages.length > 0;
        },
        data: {
            type: "singleSelect",
            title: (0, localizeUtils_1.getLocalizedString)("core.ProgrammingLanguageQuestion.title"),
            name: questionNames_1.QuestionNames.ProgrammingLanguage,
            staticOptions: [
                { id: constants_1.ProgrammingLanguage.JS, label: "JavaScript" },
                { id: constants_1.ProgrammingLanguage.TS, label: "TypeScript" },
                { id: constants_1.ProgrammingLanguage.CSharp, label: "C#" },
                { id: constants_1.ProgrammingLanguage.PY, label: "Python" },
            ],
            dynamicOptions: getLanguageOptions,
            default: getDefaultLanguage,
            skipSingleOption: true,
        },
    };
}
function folderAndAppNameCondition(inputs) {
    // skip this project when need to redirect to Kiota: 1. Feature flag enabled 2. Creating plugin/declarative copilot from existing spec 3. No plugin manifest path
    // or start with github copilot
    if (inputs[questionNames_1.QuestionNames.ProjectType] === ProjectTypeOptions_1.ProjectTypeOptions.startWithGithubCopilotOptionId) {
        return false;
    }
    return true;
}
/**
 * Scaffold question model dedicated for VS Code platform
 */
function scaffoldQuestionForVSCode(platform = teamsfx_api_1.Platform.VSCode) {
    const node = {
        data: { type: "group" },
        children: [
            (0, rootNode_1.getRootProjectTypeNode)(platform),
            languageNode(),
            {
                condition: folderAndAppNameCondition,
                data: {
                    type: "group",
                },
                children: [
                    {
                        data: (0, create_1.folderQuestion)(),
                    },
                    {
                        data: (0, create_1.appNameQuestion)(),
                    },
                    {
                        condition: (inputs) => {
                            return inputs[questionNames_1.QuestionNames.WithPlugin] === CapabilityOptions_1.DACapabilityOptions.withGC().id;
                        },
                        data: {
                            type: "group",
                        },
                        children: [
                            {
                                data: (0, create_1.GCNameQuestion)(),
                            },
                            {
                                data: (0, create_1.GCConnectionIdQuestion)(),
                            },
                        ],
                    },
                ],
            },
        ],
    };
    return node;
}
//# sourceMappingURL=createRootNode.js.map